import {
  useAgencyClientsQuery,
  type AgencyClient,
} from "@/entities/agency-client";
import {
  Button,
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
  SearchField,
  SearchFieldClearButton,
  SearchFieldGroup,
  SearchFieldInput,
  SearchFieldSearchIcon,
  Spinner,
} from "@heroui/react";
import { ChevronRight } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

export const ClientList = () => {
  const [search, setSearch] = useState("");
  const { data: clients = [], isLoading, error } = useAgencyClientsQuery();

  const filteredClients = clients.filter((client: AgencyClient) =>
    `${client.login} ${client.client_info || ""} ${client.client_id}`
      .toLowerCase()
      .includes(search.toLowerCase()),
  );

  return (
    <div className="flex flex-col gap-4">
      {/* Поисковая строка */}
      <SearchField
        value={search}
        onChange={setSearch}
        aria-label="Поиск по клиентам Яндекс Директа"
      >
        <SearchFieldGroup>
          <SearchFieldSearchIcon />
          <SearchFieldInput placeholder="Поиск по клиентам, логину или ID..." />
          <SearchFieldClearButton />
        </SearchFieldGroup>
      </SearchField>

      {/* Состояние загрузки */}
      {isLoading && (
        <div className="py-16 flex flex-col items-center justify-center gap-3">
          <Spinner size="lg" />
          <p className="text-xs text-neutral-400">
            Загрузка клиентов агентства...
          </p>
        </div>
      )}

      {/* Ошибка загрузки */}
      {!isLoading && error && (
        <div className="p-6 rounded-xl border border-red-200 bg-red-50/50 text-red-700 text-xs">
          Не удалось загрузить список клиентов. Пожалуйста, убедитесь, что
          выполнена синхронизация аккаунта.
        </div>
      )}

      {/* Список карточек клиентов */}
      {!isLoading && !error && (
        <div className="flex flex-col gap-3">
          {filteredClients.map((client) => {
            const isArchived =
              client.archived === "YES" || client.archived === true;

            return (
              <Link to={`/${client.login}`}>
                <Card
                  key={client.id || client.client_id}
                  className="hover:bg-neutral-100"
                >
                  <CardHeader className="flex flex-row items-center justify-between gap-4">
                    {/* Логотип Яндекс Директа + Название и логин клиента */}
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="min-w-0">
                        <CardTitle className="truncate">
                          {client.client_info || client.login}
                        </CardTitle>
                        <CardDescription>
                          Логин: {client.login} • ID: {client.client_id}
                        </CardDescription>
                      </div>
                    </div>

                    {/* Акцентная кнопка «Перейти» с переходом на страницу кампаний клиента */}

                    <Button
                      size="sm"
                      variant="ghost"
                      className="flex items-center gap-1.5 shrink-0"
                    >
                      <ChevronRight className="w-4 h-4" />
                    </Button>
                  </CardHeader>
                </Card>
              </Link>
            );
          })}

          {filteredClients.length === 0 && (
            <div className="py-12 text-center text-neutral-400 text-sm">
              {clients.length === 0
                ? "Клиенты агентства не найдены. Убедитесь, что у вашего аккаунта есть привязанные клиенты в Яндекс Директе."
                : `Клиенты по запросу «${search}» не найдены.`}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
